module.exports = __webpack_public_path__ + "img/ep-cadre.20799076.jpg";